// actionTypes.js
export const SET_VALUE_Pdp = "SET_VALUE_Pdp";
export const SET_TYPE_Pdp = "SET_TYPE_Pdp";
export const SET_CURRENT_PAGE_Pdp = "SET_CURRENT_PAGE_Pdp";
export const SET_ORDER_Pdp = "SET_ORDER_Pdp";
export const SET_SORT_FIELD_Pdp = "SET_SORT_FIELD_Pdp";
export const SET_ACTIF_Pdp = "SET_ACTIF_Pdp";
